import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Hp = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Hp' {...props}>
    <path fill='#333' fillRule='evenodd' d='M8.4210347,0.00016035599 L5,15.127022 L7.13818677,15.127022 L10.5590611,0.00016035599 L8.4210347,0.00016035599 Z M17.4142797,8.87313837 L15.9176772,15.0979976 L18.0557037,15.0979976 L19.5523061,8.87313837 L17.4142797,8.87313837 Z M13.7794905,8.87313837 L10.3586161,24 L12.4966425,24 L15.9176772,8.87313837 L13.7794905,8.87313837 Z M10.131552,8.87313837 L8.63478923,15.0979976 L10.7728157,15.0979976 L12.2694181,8.87313837 L10.131552,8.87313837 Z' />
  </StyledIcon>
);
